import { render, staticRenderFns } from "./EnvelopamentoConcluidos.vue?vue&type=template&id=383fa9d1"
import script from "./EnvelopamentoConcluidos.vue?vue&type=script&lang=js"
export * from "./EnvelopamentoConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports